import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import Footer, {
  FooterColumn,
  Props as FooterProps,
  SocialMedia,
  StyleProps,
} from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/footer';
import { FooterLink } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/footer/components/column';
import { Reference } from 'types/reference';
import { NextFrontasticImage } from 'frontastic/lib/image/types';
import { formatCustomerGroup } from '@loomstateorg/shared-frontend/helpers/formatter';
import { ALL_USERS_TAG } from 'helpers/hooks/usePermissionsChecker';

interface Props {
  data: any;
  customerGroup: any;
}
const FooterCmsTastic = ({ data, customerGroup }: Props) => {
  const formattedCustomerGroup = formatCustomerGroup(customerGroup?.obj?.key!);

  const getTagId = (tag: any) => tag.sys.id;
  const isMatchingTag = (tagId: string) => tagId === formattedCustomerGroup || tagId === ALL_USERS_TAG;

  const filterByTags = (items: any[]) =>
    items?.filter((item) => item.metadata?.tags?.some((tag: any) => isMatchingTag(getTagId(tag))));

  const getFields = (dataItem: any) => dataItem?.fields;

  const rawColumns = data?.data?.dataSource?.items?.[0]?.fields?.columns;
  const rawSocialMedia = data?.data?.dataSource?.items?.[0]?.fields?.socialMedia;

  const columns = [] as never[] as FooterColumn[];
  rawColumns?.forEach((column: any) => {
    const filteredLinks = filterByTags(column.fields.link)?.map(getFields);
    const links = filteredLinks?.map((link: any) => {
      return {
        name: link?.linkName,
        icon: link?.linkIcon?.fields?.file?.url,
        reference: {
          type: 'link',
          link: link?.linkUrl,
          openInNewWindow: link?.openLinkInNewTab,
        } as Reference,
      } as FooterLink;
    }) as FooterLink[];

    const footerColumns = {
      header: column?.fields?.title as string,
      links: links,
    } as FooterColumn;
    columns.push(footerColumns);
  });

  const socialMediaList = [] as never[] as SocialMedia[];
  rawSocialMedia?.forEach((socialMedia: any) => {
    const logo = {
      media: {
        file: socialMedia?.fields?.linkIcon?.fields?.file?.url,
        name: socialMedia?.fields?.linkIcon?.fields?.file?.fileName,
        width: socialMedia?.fields?.linkIcon?.fields?.file?.details?.image?.width,
        height: socialMedia?.fields?.linkIcon?.fields?.file?.details?.image?.height,
      },
    } as NextFrontasticImage;
    const reference = {
      type: 'link',
      link: socialMedia?.fields?.linkUrl,
      openInNewWindow: socialMedia?.fields?.openLinkInNewTab,
    } as Reference;

    socialMediaList.push({ logo, reference });
  });

  const styleProps = {
    backgroundImage: data?.data?.dataSource?.items?.[0]?.fields?.backgroundImage?.fields?.file?.url,
    backgroundColor: data?.data?.dataSource?.items?.[0]?.fields?.backgroundColor,
    fontColor: data?.data?.dataSource?.items?.[0]?.fields?.fontColor,
  } as StyleProps;

  return (
    <div className="fixed-screen-width lg:relative-width">
      <Footer
        columns={columns}
        socialMedia={socialMediaList}
        styleProps={styleProps}
        columnHeaderClassName={CHIPOTLE_CONTENT_LOOK.footerColumnHeaderClassName}
      />
    </div>
  );
};

export default FooterCmsTastic;
